<template>
  <v-app>
    <router-view />
  </v-app>
</template>

<style lang="scss">
html, body, #app {
  height: 100%;
  margin: 0;
}

#app{
  display: flex;
  flex-direction: column;
}
</style>
